import React from 'react';
import { CheckSquare, Calendar, Building } from 'lucide-react';

/**
 * Компонент секции с дополнительными параметрами для расчета НДС
 */
const AdditionalOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  accountingTypes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {/* Дата операции */}
        <div>
          <label htmlFor="dateOfOperation" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
            Дата операции
          </label>
          <input
            type="date"
            id="dateOfOperation"
            name="dateOfOperation"
            value={formData.dateOfOperation}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.dateOfOperation ? 'input-error' : ''}`}
          />
          {errors.dateOfOperation && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.dateOfOperation}
            </p>
          )}
        </div>

        {/* Тип учета */}
        <div>
          <label htmlFor="accountingType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Building className="w-4 h-4 mr-2 text-indigo-500" />
            Система налогообложения
          </label>
          <select
            id="accountingType"
            name="accountingType"
            value={formData.accountingType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.accountingType ? 'input-error' : ''}`}
          >
            {accountingTypes.map(type => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {formData.accountingType === 'general' && 'Стандартный режим с НДС'}
            {formData.accountingType === 'simplified' && 'УСН - упрощенная система налогообложения'}
            {formData.accountingType === 'envd' && 'ЕНВД - единый налог на вмененный доход (до 2021 г.)'}
            {formData.accountingType === 'patent' && 'ПСН - патентная система налогообложения'}
            {formData.accountingType === 'ausn' && 'АУСН - автоматизированная УСН (экспериментальный режим)'}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Дополнительный налог */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeOtherTaxes"
              checked={formData.includeOtherTaxes}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать дополнительный налог или сбор
            </span>
          </label>
        </div>

        {/* Детализация по нескольким товарам/услугам */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="showInvoiceDetails"
              checked={formData.showInvoiceDetails}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Расчет по нескольким товарам/услугам
            </span>
          </label>
        </div>

        {/* Параметры дополнительного налога, если включен */}
        {formData.includeOtherTaxes && (
          <div className="col-span-full grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800 mt-2">
            <div>
              <label htmlFor="otherTaxName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Название налога/сбора
              </label>
              <input
                type="text"
                id="otherTaxName"
                name="otherTaxName"
                value={formData.otherTaxName}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.otherTaxName ? 'input-error' : ''}`}
                placeholder="Например: Торговый сбор"
              />
              {errors.otherTaxName && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.otherTaxName}
                </p>
              )}
            </div>
            <div>
              <label htmlFor="otherTaxRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Ставка (%)
              </label>
              <input
                type="text"
                id="otherTaxRate"
                name="otherTaxRate"
                value={formData.otherTaxRate}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.otherTaxRate ? 'input-error' : ''}`}
                placeholder="Введите процент"
              />
              {errors.otherTaxRate && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.otherTaxRate}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdditionalOptionsSection;